import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { toast } from '../hooks/use-toast';

// SEC-003 — sentinelle pour passer les guards `if (!token)`; le cookie HttpOnly est envoyé via axios withCredentials.

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    handleCallback();
  }, []);

  const handleCallback = async () => {
    try {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setError('Session ID manquant');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      // Exchange session_id for token
      const response = await fetch(`${API}/auth/session/${sessionId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (data.success && data.token) {
        // SEC-06 — auth via cookie HttpOnly : ne pas stocker le JWT en localStorage (vecteur XSS)
        localStorage.setItem('baobab_user', JSON.stringify(data.user));
        
        // Update auth context
        updateUser(data.user);

        toast({
          title: "✅ Connexion réussie",
          description: `Bienvenue ${data.user.firstName} !`
        });

        // Redirect to dashboard
        window.location.href = '/dashboard';
      } else {
        throw new Error(data.detail || 'Authentication failed');
      }
    } catch (err) {
      console.error('Auth callback error:', err);
      setError(err.message || 'Erreur lors de l\'authentification');
      
      toast({
        title: "Erreur",
        description: "Impossible de finaliser la connexion avec Google",
        variant: "destructive"
      });

      setTimeout(() => navigate('/login'), 3000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-teal-50 flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-red-600 text-lg mb-4">❌ {error}</div>
            <p className="text-gray-600">Redirection vers la page de connexion...</p>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 mx-auto text-[#1db584] animate-spin mb-4" />
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Connexion en cours...
            </h2>
            <p className="text-gray-600">
              Finalisation de votre authentification Google
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
